import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { LoadingPage } from './loading/loading.page';
import { ChatbotSettingsPage } from './chatbot/pages/chatbot-settings/chatbot-settings.page';
import { disclaimerGuard } from './disclaimer.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'buddy',
    pathMatch: 'full',
  },
  {
    path: 'login',
    redirectTo: 'buddy',
    pathMatch: 'full',
  },
  {
    path: 'loading',
    component: LoadingPage,
  },
  {
    path: 'landing-page',
    loadChildren: () =>
      import('./landing-page/landing-page.module').then(
        (m) => m.LandingPagePageModule,
      ),
    canActivate: [disclaimerGuard],
  },
  {
    path: 'anonymous-flow',
    loadChildren: () =>
      import('./dwin/pages/anonymous-flow/anonymous-flow.module').then(
        (m) => m.AnonymousFlowPageModule,
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./profile/dwin-profile.module').then((m) => m.DwinProfileModule),
  },
  {
    path: 'buddy',
    loadChildren: () =>
      import('./chatbot/pages/chatbot.page.module').then(
        (m) => m.ChatbotPageModule,
      ),
    canActivate: [disclaimerGuard],
  },
  {
    path: 'terms-of-use',
    loadChildren: () =>
      import('./chatbot/pages/terms-of-use/terms-of-use.module').then(
        (m) => m.ChatbotTermsOfUseModule,
      ),
  },
  {
    path: 'legal',
    loadChildren: () =>
      import('src/app/legal-pages/legal-pages.module').then(
        (m) => m.LegalPagesModule,
      ),
  },
  {
    path: '**',
    pathMatch: 'full',
    loadChildren: () =>
      import('./page-not-found/page-not-found.module').then(
        (m) => m.PageNotFoundPageModule,
      ),
  },
  {
    path: 'settings',
    component: ChatbotSettingsPage,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
